import { Icon } from '@benzinga/core-ui';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons/faSpinner';
import React from 'react';
import styles from './mortgage.module.scss';

type SubmitProps = {
  isSubmitting: boolean;
  submit: () => void;
  text: string;
};

export const Submit: React.FC<SubmitProps> = ({ isSubmitting, submit, text }) => {
  return (
    <button
      className={`${styles.cta} inline-flex items-center justify-center font-bold uppercase`}
      disabled={isSubmitting}
      onClick={() => submit()}
      type="button"
    >
      {isSubmitting ? <Icon icon={faSpinner} spin={true} /> : text}
    </button>
  );
};
